import styled, { css } from 'styled-components';
import themeData from 'utils/theme/themeData';

const { typography } = themeData;

export const FormWrapper = styled.div`
  text-align: center;
`;

export const FormTitle = styled.h3`
  margin: 0;
  font-weight: 700;
  font-size: 16px;
  line-height: 24px;
  color: ${({ theme }) => theme.colors.grey600};
`;

export const ReasonInput = styled.textarea`
  width: 100%;
  height: 76px;
  padding: 14px 20px;
  font-size: 13px;
  line-height: 20px;
  color: ${({ theme }) => theme.colors.black};
  border: 1px solid ${({ theme, error }) => (error ? theme.colors.redMain : theme.colors.grey003)};
  border-radius: 4px;
  box-sizing: border-box;
  resize: none;

  &::placeholder {
    font-size: 13px;
    line-height: 20px;
    color: ${({ theme }) => theme.colors.grey002};
  }

  &:focus {
    border: 2px solid ${({ theme }) => theme.colors.blueMain};
    outline: none;
  }
`;

export const ValidationErrMsg = styled(typography.BodyTextOneRegularTypography)`
  margin: 0;
  color: ${({ theme }) => theme.colors.redMain};
  text-align: start;
`;

export const BlockButton = styled.button`
  cursor: pointer;
  padding: 10px 0;
  width: 100%;
  border-radius: 4px;
  background-color: ${({ theme }) => theme.colors.redMain};
  border: none;
  color: ${({ theme }) => theme.colors.white};
  font-weight: 600;
  font-size: 14px;
  line-height: 20px;
`;

export const UnblockButton = styled.button`
  cursor: pointer;
  padding: 10px 0;
  width: 100%;
  border-radius: 4px;
  background-color: ${({ theme }) => theme.colors.blueMain};
  border: none;
  color: ${({ theme }) => theme.colors.white};
  font-weight: 600;
  font-size: 14px;
  line-height: 20px;
`;

export const NameTag = styled.div`
  display: inline-block;
  background-color: ${({ theme }) => theme.colors.greenLight};
  border: 1px solid ${({ theme }) => theme.colors.greenDark};
  border-radius: 4px;
  padding: 8px 24px;
  margin: 0 auto;
  color: ${({ theme }) => theme.colors.grey600};
  font-weight: 400;
  font-size: 14px;
  line-height: 22px;
`;

export const extendLoaderStyle = css`
  margin: 0 auto;
`;
